import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Shield } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ThirdPartyRatingFilterProps {
  includeThirdPartyRating: boolean;
  onToggle: (checked: boolean) => void;
}

const ThirdPartyRatingFilter: React.FC<ThirdPartyRatingFilterProps> = ({
  includeThirdPartyRating,
  onToggle,
}) => {
  const { t } = useTranslation('practitioners');

  return (
    <Card className="border border-gray-200">
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Shield className="h-4 w-4 text-blue-600" />
            <Label htmlFor="third-party-rating" className="text-sm font-semibold">
              Include Third-Party Ratings
            </Label>
          </div>
          <Switch
            id="third-party-rating"
            checked={includeThirdPartyRating}
            onCheckedChange={onToggle}
          />
        </div>
        <p className="text-xs text-gray-500 mt-2 pl-6">
          Show practitioners with verified ratings from other platforms
        </p>
      </CardContent>
    </Card>
  );
};

export default ThirdPartyRatingFilter;